module.exports = __webpack_public_path__ + "img/revenuesTypes.3c764f89.svg";